module.exports = __webpack_public_path__ + "img/20200425145442472.35e86573.png";